import { Cladding } from '../../../../Sections/properties';
import { getEnumObjectDiffOptionRows, getEnumObjectIdenticalOptionRows } from '../../optionRowData';

/**
 * Returns all identical options
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getIdenticalCladdingOptionRows = (planValue, liveValue) => {
    return getEnumObjectIdenticalOptionRows(Cladding, planValue, liveValue);
};

/**
 * Returns all options which are
 *
 * @param planValue
 * @param liveValue
 * @return {{key: string, left: *, right: *}[]}
 */
export const getDiffCladdingOptionRows = (planValue, liveValue) => {
    return getEnumObjectDiffOptionRows(Cladding, planValue, liveValue);
};
